export default __webpack_public_path__ + "static/RTG_PDP_LOGO_DISNEY_230x100-dbfbdbb887cdb513bf34c8b7a5544616.png";